
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {Link, IndexLink} from 'react-router'
import Icon from 'components/Icon'

export default class MenuItem extends React.Component {
  static propTypes = {
    to: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func
  }

  static defaultProps = {
    to: '/'
  }

  render() {
    const {to, icon, children, onClick} = this.props
    const LinkComponent = to === '/' ? IndexLink : Link

    if (onClick) {
      return (
        <li className='menu-item'>
          <div
            onClick={onClick}
            className='menu-item_link'
          >
            {icon ? <Icon className='menu-item_link-icon' name={icon} size='26px' /> : null}
            {children}
          </div>
        </li>
      )
    }

    return (
      <li className='menu-item'>
        <LinkComponent
          onClick={onClick}
          className='menu-item_link'
          to={to}
          activeClassName='is-active'
        >
          {icon ? <Icon className='menu-item_link-icon' name={icon} size='26px' /> : null}
          {children}
        </LinkComponent>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/MenuItem/index.js